
import { default as axios, AxiosResponse } from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import BarometerCollection from '../../components/overview/BarometerCollection.vue';
import Dashboard from '../../components/overview/Dashboard.vue';
import KpiTrend from '../../components/overview/KpiTrend.vue';
import Collapsible from '../../components/shared/Collapsible.vue';
import { IEvolution } from '../../shared/contracts/EvolutionContract';
import { IMemberWithoutBarometerHypermediaRepresentation } from '../../shared/contracts/MemberContract';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { IGroupDetailsState } from '../../store/contract';
@Component({
    components: {
        Dashboard,
        KpiTrend,
        Collapsible,
        BarometerCollection
    }
})
export default class GroupDetailsBase extends Vue {
    @Prop() id: string;

    @State('details') groupDetailState: IGroupDetailsState;

    protected actionSnapshots: ISnapshotHypermediaRepresentation[] = [];
    protected areActionsLoading: boolean = false;
    protected membersWithoutBarometer: IMemberWithoutBarometerHypermediaRepresentation[] = [];
    protected areMembersLoading: boolean = false;
    protected actionsLoaded: boolean = false;

    private evolution: IEvolution = null;

    protected showKpi = true;

    async created() {
        this.retrieveActionSnapshots();
        this.retrieveMembersWithoutBarometer();
        this.retrieveEvolution();
    }

    protected retrieveActionSnapshots() {
        this.areActionsLoading = true;
        return axios
            .get(this.groupDetailState.aggregate._links.item_people_actions.href)
            .then((response: AxiosResponse<ISnapshotHypermediaRepresentation[]>) => {
                return this.filterAnswersFromSnapshots(response.data);
            }).then(actionSnapshots => {
                this.actionSnapshots = actionSnapshots;
                this.actionsLoaded = true;
                this.areActionsLoading = false;
            });
    }

    protected retrieveEvolution() {
        return axios
            .get(this.groupDetailState.aggregate._links.item_evolution.href)
            .then((response: AxiosResponse<IEvolution>) => {
                this.evolution = response.data;
            });
    }

    protected retrieveMembersWithoutBarometer() {
        const link = this.groupDetailState.aggregate._links.item_members_without_barometer;
        if (link && link.href) {
            this.areMembersLoading = true;
            return axios
                .get(link.href)
                .then((response: AxiosResponse<IMemberWithoutBarometerHypermediaRepresentation[]>) => {
                    this.membersWithoutBarometer = response.data;
                    this.areMembersLoading = false;
                })
                .catch(() => {
                    // Silently fail if the endpoint is not available
                    this.membersWithoutBarometer = [];
                    this.areMembersLoading = false;
                });
        }
        return Promise.resolve();
    }

    protected dashboardLoaded() {
        if (this.actionsLoaded) {
            this.markPerformance();
        }
    }

    protected markPerformance() {
        // Implement in subclass;
    }

    protected async filterAnswersFromSnapshots(snapshots: ISnapshotHypermediaRepresentation[]): Promise<ISnapshotHypermediaRepresentation[]> {
        return snapshots;
    }

}
